import { Edit } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useRecordContext } from "react-admin";
import { useFormContext } from "react-hook-form";
import { dmsApi, largeUploadApi  } from "../../url";
import "./fileInputStyle.css";
import  *  as  lodash  from 'lodash';
// import { readFileSync } from "fs";

export const FileInputSingle = ({
  title = "Upload File",
  edit = false,
  upload = true,
  resource,
  route,
  field,
  resourceField,
  add,
  ...props
}) => {
  const b = useFormContext();
  const c = useRecordContext(props);
  const [files, setFiles] = useState([{ document: c?.image }]);

  const handleFileUpload = async (e, i) => {
    // console.log(files[0].document);
    // console.log(e.target);
    const uploadUrl = await fetch(
      `${largeUploadApi}?fileType=${files[0].document}`,
      { method: "POST" }
    );
    if (uploadUrl.status == 200) {
      const s3SignedUrlFull = await uploadUrl.json();
      const s3SignedUrl = s3SignedUrlFull["body"];
      console.log(s3SignedUrlFull);
      var xhr = new XMLHttpRequest();
      xhr.open("PUT", s3SignedUrl, true);
      xhr.setRequestHeader("Content-Type", files[0].type);
      xhr.onload = () => {
        if (xhr.status === 200) {
          // success!
        }
      };
      xhr.onerror = () => {
        // error...
      };
      xhr.send(files[0]);
      // await fetch(s3Url, {
      //   method: "PUT",
      //   body: readFileSync(e.target.files900),
      // })
      //   .then((res) => res.json())
      //   .then((body) => {
      //     if (body.document) {
      //       const copy = [...files];
      //       copy[i] = {
      //         document: body.document,
      //         // name: body.result.name,
      //         // reference: copy?.[i]?.reference ?? "",
      //       };
      //       setFiles(copy);
      //     }
      //   });
    }
  };
  useEffect(() => {
    if (b && b.setValue) {
      b.setValue(props.source, files[0].document);
    }
  }, [files]);

  function previewFile(file) {
    if (/(.pdf)$/.test(file.document)) {
      return (
        <div className="file">
          <iframe src={file.document} width="600px" height="600px"></iframe>
        </div>
      );
    } else if (/(.mp4)$/.test(file.document)) {
      return (
        <video width="600px" height="600px" controls>
          <source src={file.document} type="video/mp4"></source>
        </video>
      );
    } else if (
      /(.jpg)$/.test(file.document) ||
      /(.jpeg)$/.test(file.document) ||
      /(.png)$/.test(file.document)
    ) {
      return (
        <div>
          <img src={file.document} width="600px" height="600px"></img>
        </div>
      );
    } else {
      return null;
    }
  }

  return (
    <div>
      <h3>{title}</h3>
      {(files ?? [{ link: "", name: "", reference: "" }]).map((file, index) => {
        return (
          <React.Fragment key={index}>
            {edit && (
              <IconButton
                onClick={() => {
                  const copy = [...files];
                  copy[index] = { ...copy[index], link: "", name: "" };
                  setFiles(copy);
                }}
              >
                {" "}
                <Edit />
              </IconButton>
            )}
            {!file.document && upload ? (
              <label className="fileInput" value="">
                <input
                  type="file"
                  onChange={(e) => handleFileUpload(e, index)}
                  accept="image/*, application/pdf, video/mp4, video/x-m4v, video/*"
                />
                Upload
              </label>
            ) : (
              previewFile(file)
            )}
          </React.Fragment>
        );
      })}
      <br />
      {/* {add && (
        <Button onClick={addFile} startIcon={<AddOutlined />}>
          {" "}
          Add
        </Button>
      )} */}
    </div>
  );
};
